// The saved per-row binding is legacy metadata. It may belong to a row that
// previously occupied this index, especially after adding/removing charges.
// Only use its missing fields if it still describes the selected charge.
export const resolvePopupRowData = (row, binding) => {
  if (!row) return null;
  if (!binding) return row;

  const normalize = (value) => String(value ?? "").trim().replace(/\s+/g, " ").toLowerCase();
  const rowName = normalize(row.chargeName);
  const bindingName = normalize(binding.chargeName);
  if (!rowName || !bindingName || rowName !== bindingName) return row;
  if (row.decoratorId != null && binding.decoratorId != null &&
      String(row.decoratorId) !== String(binding.decoratorId)) return row;

  return {
    ...binding,
    ...row,
    chargeId: row.chargeId ?? binding.chargeId ?? null,
    decoratorId: row.decoratorId ?? binding.decoratorId ?? null,
    supplierId: row.supplierId ?? binding.supplierId ?? null,
    addressId: row.addressId ?? binding.addressId ?? null,
    productionDepartmentId: row.productionDepartmentId ?? binding.productionDepartmentId ?? null,
    productionInputLabel: row.productionInputLabel ?? binding.productionInputLabel ?? null,
    productionInputValue: row.productionInputValue ?? binding.productionInputValue ?? null,
  };
};
